
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/slider",
      function () {
        return require("private-next-pages/joy-ui/api/slider.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/slider"])
      });
    }
  